import * as React from 'react';
import { KEY_CODE } from '~/helpers/consts';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { hideDialog } from '~/Actions/ActionCategory';
import { loadAppData } from '~/Actions/ActionApp';
import { State } from '~/Reducers';
import ContainerView from '~/Containers/ContainerView';
import { default as globalStyles } from '../styles/global.scss';
import { t } from '~/helpers/localization';
import { IResponse } from '~/interfaces';
import dwhExport from '~/helpers/dwhExport';
import { Button, DialogContainer, DialogFooter, DialogHeader, Processing } from '@wg/wows-react-uikit';

interface IState {
    response: IResponse;
    promoWidget: any;
    isErrorLoad: boolean;
}

const stateSelector = (state: State): IState => {
    return {
        response: state.ReducerApp.response,
        promoWidget: state.ReducerApp.promoWidget,
        isErrorLoad: state.ReducerApp.isErrorLoad,
    };
};

const ContainerApp = () => {
    const dispatch = useDispatch();
    const appState = useSelector<State, IState>(stateSelector, shallowEqual);

    React.useEffect(() => {
        dispatch(loadAppData());

        dwhExport.appStart();

        document.addEventListener('keydown', (event) => {
            if (event.keyCode === KEY_CODE.ESC) {
                dispatch(hideDialog());
            }
        });
    }, []);

    if (appState.isErrorLoad) {
        return (
            <div className={globalStyles.dialogWrap}>
                <DialogContainer>
                    <DialogHeader noUnderline={true}>{t('Произошла ошибка, пожалуйста, повторите попытку позже')}</DialogHeader>
                    <DialogFooter>
                        <Button onClick={() => dispatch(loadAppData())}>{t('Обновить')}</Button>
                    </DialogFooter>
                </DialogContainer>
            </div>
        );
    } else if (!appState.response) {
        return <Processing isFetching={true} />;
    }

    return <ContainerView isNeedToShowWelcomePage={false} />;
};

export default ContainerApp;
